import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SiteWorkOrdersService } from 'app/_services/site-work-orders.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'edit-description-modal',
  templateUrl: './edit-description-modal.component.html',
})
export class EditDescriptionModalComponent implements OnInit {
  @Input() workOrder: any;

  public form: FormGroup;

  constructor(
    private activeModal: NgbActiveModal,
    private workOrderService: SiteWorkOrdersService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      description: new FormControl(this.workOrder.description, [Validators.required, Validators.maxLength(255)]),
    });
  }

  public closeModal() {
    this.activeModal.dismiss();
  }


  public onSubmit() {
    const values = this.form.value;

    const body = {
      description: values.description,
      // required for the PUT Request:
      id: this.workOrder.id,
      released: this.workOrder.released,
      approvalStatus: this.workOrder.approvalStatus,
      minimumPartySize: this.workOrder.minimumPartySize,
      checkOnSiteFormId: this.workOrder.checkOnSiteFormId,
      checkOffSiteFormId: this.workOrder.checkOffSiteFormId,
      scheduledStartTime: this.workOrder.scheduledStartTime,
      scheduledEndTime: this.workOrder.scheduledEndTime,
      exemptFromAssetScheduling: this.workOrder.exemptFromAssetScheduling,
    };

    this.workOrderService.updateWorkOrder(body).subscribe(() => {
      Swal.fire('Updated!', 'Work Order has been updated.', 'success');
      this.activeModal.close('refresh');
    });
  }
}
